import React, { useState, useRef, useLayoutEffect } from "react";
import { Search, Users, ChevronDown, ChevronRight, X } from "lucide-react";
import "./Organigramme.css";

/* ─── Données statiques ────────────────────────────────────────────── */
const STATIC_TREE = [
    {
        id: 1, code: "DIR", name: "Direction Générale", badge: "Direction", members: 12,
        responsable: { fullName: "Ahmed Benali", jobName: "Directeur Général" },
        children: [
            {
                id: 2, code: "IT", name: "Informatique", badge: "Département", members: 18,
                responsable: { fullName: "Karim Idrissi", jobName: "DSI" },
                children: [
                    {
                        id: 3, code: "IT-DEV", name: "IT — Développement", badge: "Service", members: 10,
                        responsable: { fullName: "Sara Tazi", jobName: "Lead Dev" },
                        children: [
                            { id: 6,  code: "IT-DEV-BACK",  name: "Dev Backend",   badge: "Équipe", members: 4,  responsable: null, children: [] },
                            { id: 7,  code: "IT-DEV-FRONT", name: "Dev Frontend",  badge: "Équipe", members: 3,  responsable: null, children: [] },
                            { id: 8,  code: "IT-DEV-MOB",   name: "Dev Mobile",    badge: "Équipe", members: 3,  responsable: null, children: [] },
                        ],
                    },
                    {
                        id: 4, code: "IT-INFRA", name: "IT — Infrastructure", badge: "Service", members: 8,
                        responsable: { fullName: "Youssef Alami", jobName: "Responsable Infra" },
                        children: [
                            { id: 9,  code: "IT-INFRA-SYS", name: "Systèmes",    badge: "Équipe", members: 3, responsable: null, children: [] },
                            { id: 10, code: "IT-INFRA-SEC", name: "Sécurité SI",  badge: "Équipe", members: 2, responsable: null, children: [] },
                            { id: 11, code: "IT-INFRA-RES", name: "Réseaux",      badge: "Équipe", members: 3, responsable: null, children: [] },
                        ],
                    },
                ],
            },
            {
                id: 5, code: "RH", name: "Ressources Humaines", badge: "Département", members: 15,
                responsable: { fullName: "Nadia Berrada", jobName: "DRH" },
                children: [
                    {
                        id: 12, code: "RH-REC", name: "Recrutement", badge: "Service", members: 5,
                        responsable: null,
                        children: [
                            { id: 15, code: "RH-REC-INT", name: "Recrutement interne", badge: "Équipe", members: 2, responsable: null, children: [] },
                            { id: 16, code: "RH-REC-EXT", name: "Recrutement externe", badge: "Équipe", members: 3, responsable: null, children: [] },
                        ],
                    },
                    { id: 13, code: "RH-FORM", name: "Formation",             badge: "Service", members: 4, responsable: null, children: [] },
                    {
                        id: 14, code: "RH-PAIE", name: "Paie & Administration", badge: "Service", members: 6,
                        responsable: null,
                        children: [
                            { id: 17, code: "RH-PAIE-PAY", name: "Paie",             badge: "Équipe", members: 3, responsable: null, children: [] },
                            { id: 18, code: "RH-PAIE-ADM", name: "Administration RH", badge: "Équipe", members: 3, responsable: null, children: [] },
                        ],
                    },
                ],
            },
            {
                id: 19, code: "FIN", name: "Finance", badge: "Département", members: 14,
                responsable: { fullName: "Omar Fassi", jobName: "DAF" },
                children: [
                    {
                        id: 20, code: "FIN-COMPTA", name: "Comptabilité", badge: "Service", members: 6,
                        responsable: null,
                        children: [
                            { id: 23, code: "FIN-COMPTA-GEN", name: "Comptabilité générale",     badge: "Équipe", members: 2, responsable: null, children: [] },
                            { id: 24, code: "FIN-COMPTA-CLT", name: "Comptabilité clients",      badge: "Équipe", members: 2, responsable: null, children: [] },
                            { id: 25, code: "FIN-COMPTA-FRS", name: "Comptabilité fournisseurs", badge: "Équipe", members: 2, responsable: null, children: [] },
                        ],
                    },
                    {
                        id: 21, code: "FIN-CONT", name: "Contrôle de gestion", badge: "Service", members: 4,
                        responsable: null,
                        children: [
                            { id: 26, code: "FIN-CONT-BUD", name: "Budget",    badge: "Équipe", members: 2, responsable: null, children: [] },
                            { id: 27, code: "FIN-CONT-REP", name: "Reporting", badge: "Équipe", members: 2, responsable: null, children: [] },
                        ],
                    },
                    { id: 22, code: "FIN-TRES", name: "Trésorerie", badge: "Service", members: 4, responsable: null, children: [] },
                ],
            },
            {
                id: 28, code: "COM01", name: "Commercial", badge: "Département", members: 20,
                responsable: { fullName: "Rachid Mounir", jobName: "Directeur Commercial" },
                children: [
                    {
                        id: 29, code: "COM01-VTE", name: "Ventes", badge: "Service", members: 10,
                        responsable: null,
                        children: [
                            { id: 32, code: "COM01-VTE-NAT", name: "Ventes national",      badge: "Équipe", members: 5, responsable: null, children: [] },
                            { id: 33, code: "COM01-VTE-INT", name: "Ventes international",  badge: "Équipe", members: 5, responsable: null, children: [] },
                        ],
                    },
                    {
                        id: 30, code: "COM01-MKT", name: "Marketing", badge: "Service", members: 6,
                        responsable: null,
                        children: [
                            { id: 34, code: "COM01-MKT-DIG", name: "Marketing digital", badge: "Équipe", members: 3, responsable: null, children: [] },
                            { id: 35, code: "COM01-MKT-COM", name: "Communication",     badge: "Équipe", members: 3, responsable: null, children: [] },
                        ],
                    },
                    { id: 31, code: "COM01-GRC", name: "Relation client (CRM)", badge: "Service", members: 4, responsable: null, children: [] },
                ],
            },
            {
                id: 36, code: "SUP", name: "Support", badge: "Département", members: 12,
                responsable: { fullName: "Fatima Zahrae", jobName: "Responsable Support" },
                children: [
                    {
                        id: 37, code: "SUP-HELP", name: "Helpdesk", badge: "Service", members: 5,
                        responsable: null,
                        children: [
                            { id: 40, code: "SUP-HELP-L1A", name: "Helpdesk apps",     badge: "Équipe", members: 3, responsable: null, children: [] },
                            { id: 41, code: "SUP-HELP-L1M", name: "Helpdesk matériel", badge: "Équipe", members: 2, responsable: null, children: [] },
                        ],
                    },
                    { id: 38, code: "SUP-N2",   name: "Support niveau 2",    badge: "Service", members: 4, responsable: null, children: [] },
                    {
                        id: 39, code: "SUP-QUAL", name: "Qualité & processus", badge: "Service", members: 3,
                        responsable: null,
                        children: [
                            { id: 42, code: "SUP-QUAL-ISO",  name: "Certification ISO",    badge: "Équipe", members: 2, responsable: null, children: [] },
                            { id: 43, code: "SUP-QUAL-PROC", name: "Processus & méthodes", badge: "Équipe", members: 1, responsable: null, children: [] },
                        ],
                    },
                ],
            },
        ],
    },
];

/* ─── Helpers ──────────────────────────────────────────────────────── */
function flatNodes(tree = []) {
    const out = [];
    const walk = (n) => { out.push(n); (n.children || []).forEach(walk); };
    tree.forEach(walk);
    return out;
}

/* ─── Avatar ───────────────────────────────────────────────────────── */
function Avatar({ name, size = 18 }) {
    const initial = (name || "?")[0].toUpperCase();
    return (
        <span className="sav" style={{ "--sav-size": `${size}px` }}>
      {initial}
    </span>
    );
}

/* ─── Card ─────────────────────────────────────────────────────────── */
function OrgCard({ node, level, isOpen, hasChildren, onToggle, onOpen }) {
    const lvClass = `otree-card--lv${Math.min(level, 3)}`;
    return (
        <div className={`otree-card-box ${lvClass}`}>
            <button type="button" className="otree-card-main" onClick={() => onOpen(node)}>
                <div className="otree-card-top">
                    <span className="otree-card-name">{node.name}</span>
                    <span className="otree-card-badge">{node.badge}</span>
                </div>
                <div className="otree-card-meta">
          <span className="otree-card-pill">
            <Users size={9} /> {node.members} membre{node.members !== 1 ? "s" : ""}
          </span>
                    {node.responsable && (
                        <span className="otree-card-resp">
              <Avatar name={node.responsable.fullName} size={14} />
              <span className="otree-card-respname">{node.responsable.fullName}</span>
            </span>
                    )}
                </div>
            </button>
            {hasChildren && (
                <button type="button" className="otree-card-toggle" onClick={onToggle}>
                    {isOpen ? <ChevronDown size={13} /> : <ChevronRight size={13} />}
                </button>
            )}
        </div>
    );
}

/* ─── ChildrenRow (barre horizontale dynamique) ─────────────────────── */
function ChildrenRow({ nodes, level, expanded, onToggle, onOpen }) {
    const rowRef = useRef(null);
    const [barStyle, setBarStyle] = useState({ left: 0, width: 0 });

    useLayoutEffect(() => {
        const recalc = () => {
            if (!rowRef.current) return;
            const cols = rowRef.current.querySelectorAll(":scope > .otree-child-wrap");
            if (cols.length < 2) return;
            const rowRect = rowRef.current.getBoundingClientRect();
            const firstCard = cols[0].querySelector(".otree-card-box");
            const lastCard  = cols[cols.length - 1].querySelector(".otree-card-box");
            if (!firstCard || !lastCard) return;
            const fR = firstCard.getBoundingClientRect();
            const lR = lastCard.getBoundingClientRect();
            const left  = fR.left + fR.width / 2 - rowRect.left;
            const right = lR.left + lR.width / 2 - rowRect.left;
            setBarStyle({ left, width: right - left });
        };

        recalc();
        const t = setTimeout(recalc, 50); // fallback après peinture complète

        const observer = new ResizeObserver(recalc);
        if (rowRef.current) observer.observe(rowRef.current);
        return () => { clearTimeout(t); observer.disconnect(); };
    }, [nodes, expanded]);

    return (
        <div style={{ position: "relative" }}>
            <div className="otree-hbar" style={{ left: barStyle.left, width: barStyle.width }} />
            <div ref={rowRef} className="otree-children-row">
                {nodes.map((child) => (
                    <div key={child.id} className="otree-child-wrap">
                        <div className="otree-vline" />
                        <OrgNode node={child} level={level} expanded={expanded} onToggle={onToggle} onOpen={onOpen} />
                    </div>
                ))}
            </div>
        </div>
    );
}

/* ─── Node ─────────────────────────────────────────────────────────── */
function OrgNode({ node, level, expanded, onToggle, onOpen }) {
    const children = node.children || [];
    const hasChildren = children.length > 0;
    const isOpen = expanded.has(node.id);

    return (
        <div className="otree-node">
            <OrgCard
                node={node} level={level}
                isOpen={isOpen} hasChildren={hasChildren}
                onToggle={() => onToggle(node.id)}
                onOpen={onOpen}
            />
            {hasChildren && isOpen && (
                <div className="otree-children">
                    <div className="otree-vline" />
                    {children.length === 1 ? (
                        <OrgNode node={children[0]} level={level + 1} expanded={expanded} onToggle={onToggle} onOpen={onOpen} />
                    ) : (
                        <ChildrenRow nodes={children} level={level + 1} expanded={expanded} onToggle={onToggle} onOpen={onOpen} />
                    )}
                </div>
            )}
        </div>
    );
}

/* ─── Panel entité ──────────────────────────────────────────────────── */
function EntityPanel({ entity, onClose }) {
    return (
        <>
            <div className="sorgModal-header">
                <div>
                    <div className="sorgModal-header-name">{entity.name}</div>
                    <div className="sorgModal-header-sub">{entity.members} membre{entity.members !== 1 ? "s" : ""} · {entity.code}</div>
                </div>
                <button className="sorgModal-close" onClick={onClose} type="button"><X size={15} /></button>
            </div>
            <div className="sorgModal-body">
                {entity.responsable && (
                    <div className="sorgModal-section">
                        <div className="sorgModal-section-title">Responsable</div>
                        <div className="sorgModal-person">
                            <Avatar name={entity.responsable.fullName} size={38} />
                            <div>
                                <div className="sorgModal-person-name">{entity.responsable.fullName}</div>
                                <div className="sorgModal-person-role">{entity.responsable.jobName}</div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="sorgModal-section">
                    <div className="sorgModal-section-title">Informations</div>
                    <div className="sorgModal-info-grid">
                        <div className="sorgModal-info-row">
                            <span className="sorgModal-info-label">Code</span>
                            <span className="sorgModal-info-val">{entity.code}</span>
                        </div>
                        <div className="sorgModal-info-row">
                            <span className="sorgModal-info-label">Catégorie</span>
                            <span className="sorgModal-info-val">{entity.badge}</span>
                        </div>
                        <div className="sorgModal-info-row">
                            <span className="sorgModal-info-label">Membres</span>
                            <span className="sorgModal-info-val">{entity.members}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

/* ─── Composant principal ───────────────────────────────────────────── */
export default function OrganigrammeStatic() {
    const allNodes = flatNodes(STATIC_TREE);
    const [expanded, setExpanded] = useState(() => new Set(allNodes.map((n) => n.id)));
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [search, setSearch] = useState("");

    const deptOptions = [
        { id: "ALL", name: "Tous les départements" },
        ...STATIC_TREE[0].children.map((c) => ({ id: c.id, name: c.name })),
    ];
    const [deptFilter, setDeptFilter] = useState("ALL");

    const visibleTree =
        deptFilter === "ALL"
            ? STATIC_TREE
            : [STATIC_TREE[0].children.find((c) => String(c.id) === String(deptFilter))].filter(Boolean);

    const toggleExpand = (id) =>
        setExpanded((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });

    const searchMatches =
        search.trim().length > 1
            ? allNodes
                .filter((n) => n.name.toLowerCase().includes(search.trim().toLowerCase()))
                .slice(0, 6)
            : [];

    return (
        <div className="sorg">
            {/* Toolbar */}
            <div className="sorg-toolbar">
                <div className="sorg-toolbar-left">
                    <h1 className="sorg-title">Organigramme</h1>
                    <p className="sorg-subtitle">43 entités · aperçu statique</p>
                </div>
                <div className="sorg-toolbar-right">
                    <div className="sorg-search-wrap">
                        <Search className="sorg-search-icon" size={14} />
                        <input
                            className="sorg-search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Rechercher une entité…"
                        />
                        {search && (
                            <button className="sorg-search-clear" onClick={() => setSearch("")} type="button">
                                <X size={12} />
                            </button>
                        )}
                        {searchMatches.length > 0 && (
                            <div className="sorg-suggest">
                                {searchMatches.map((n) => (
                                    <button
                                        key={n.id} type="button" className="sorg-suggest-item"
                                        onClick={() => { setSelectedEntity(n); setSearch(""); }}
                                    >
                                        <div className="sorg-suggest-name">{n.name}</div>
                                        <div className="sorg-suggest-meta">{n.badge} · {n.code}</div>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                    <select
                        className="sorg-select"
                        value={deptFilter}
                        onChange={(e) => setDeptFilter(e.target.value)}
                    >
                        {deptOptions.map((o) => (
                            <option key={o.id} value={o.id}>{o.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Canvas */}
            <div className="sorg-canvas">
                <div className="sorg-tree">
                    {visibleTree.map((n) => (
                        <OrgNode
                            key={n.id} node={n} level={0}
                            expanded={expanded} onToggle={toggleExpand}
                            onOpen={setSelectedEntity}
                        />
                    ))}
                </div>
            </div>

            {/* Modal */}
            {selectedEntity && (
                <div className="sorgModal" role="dialog" aria-modal="true">
                    <div className="sorgModal-overlay" onClick={() => setSelectedEntity(null)} />
                    <div className="sorgModal-panel">
                        <EntityPanel entity={selectedEntity} onClose={() => setSelectedEntity(null)} />
                    </div>
                </div>
            )}
        </div>
    );
}